import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './pages/spyfamily/index'
import MApp from './pages/spyfamily/mpage/index';
import { isPC } from './utils';
import '@/utils/i18n'
import '@/utils/erdura'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {isPC() ? (
      <App />
    ) : (
      <MApp />
    )}
  </React.StrictMode>,
)
